// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1PkrZ","content":"LayoutSettings_content__3rxPa"};